import { render, staticRenderFns } from "./FormulaHorizontalHeader.vue?vue&type=template&id=44f935cf&scoped=true&"
import script from "./FormulaHorizontalHeader.vue?vue&type=script&lang=js&"
export * from "./FormulaHorizontalHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormulaHorizontalHeader.vue?vue&type=style&index=0&id=44f935cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f935cf",
  null
  
)

export default component.exports